import { getDocs, Query, query, QuerySnapshot, where } from "firebase/firestore";

import { appFaultModel } from "@/core/modules/appFault/models/AppFaultModel";
import { EmployeePosition } from "@/features/modules/employeePosition/objects/EmployeePosition";
import { employeePositionModel } from "../EmployeePositionModel";

export const getEmployeePositionsByBranch = async (branchId: string): Promise<EmployeePosition[]> => {
  try {
    const snapshotQuery: Query<EmployeePosition> = query(
      employeePositionModel.getGroupPathReference().withConverter(employeePositionModel.firestoreConverter),
      where("branch.id", "==", branchId)
    );

    const snapshot: QuerySnapshot<EmployeePosition> = await getDocs(employeePositionModel.addReadConditionToQuery(snapshotQuery));

    if (snapshot == undefined || snapshot.empty) return [];

    return snapshot.docs.map((doc) => doc.data());
  } catch (error: unknown) {
    appFaultModel.catchAppError("EmployeePositionModel.getEmployeePositionsByBranch", { branchId }, error);
    return [];
  }
};
